import { GetSale } from "../../../WorkSpace/Components/ApiServices/apiHandler";

export const fetchAllSale = () => {
    return dispatch => {
        dispatch({type:"SALE_ACTION_START"})
        GetSale().then((result)=>{
            dispatch({
                type: "SALE_FETCH_DATA",
                payload: result.data.sales || result.data.sale || []
            }) 
        }).catch((error)=>{
            dispatch({
                type: "SALE_FETCH_DATA_FAILED",
                payload: error.response?.data?.error
            }) 
        });
    }
}